import { useCallback } from 'react'

import type {
  InviteMemberFormData,
  OrganizationRoleKey,
} from '@/components/org-settings/members/members.interface'

import { useMemberConfirmHandlers } from './use-member-confirm-handlers.hook'
import type { UseMembersSettingsReturn } from './use-members-settings.hook'

interface UseMembersDialogHandlersProps {
  memberToRemoveId: string | null
  invitationToRevokeId: string | null
  setIsInviteDialogOpen: (isOpen: boolean) => void
  setMemberToRemoveId: (id: string | null) => void
  setInvitationToRevokeId: (id: string | null) => void
  setIsLeaveDialogOpen: (isOpen: boolean) => void
}

export const useMembersDialogHandlers = (props: UseMembersDialogHandlersProps) => {
  const confirmHandlers = useMemberConfirmHandlers({
    memberToRemoveId: props.memberToRemoveId,
    invitationToRevokeId: props.invitationToRevokeId,
    setMemberToRemoveId: props.setMemberToRemoveId,
    setInvitationToRevokeId: props.setInvitationToRevokeId,
    setIsLeaveDialogOpen: props.setIsLeaveDialogOpen,
  })

  const handleInvite = useCallback(
    (settings: UseMembersSettingsReturn) =>
      async (data: InviteMemberFormData): Promise<void> => {
        await settings.handleInvite(data)
        props.setIsInviteDialogOpen(false)
      },
    [props.setIsInviteDialogOpen]
  )

  const handleRoleChange = useCallback(
    (settings: UseMembersSettingsReturn) =>
      (memberId: string, role: OrganizationRoleKey): void => {
        settings.handleRoleChange(memberId, role)
      },
    []
  )

  return { handleInvite, handleRoleChange, ...confirmHandlers }
}
